import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientsPage } from './patients';
import { TranslateModule } from '@ngx-translate/core'; // Required for translation.
import { DirectivesModule } from '../../directives/directives.module';
import { MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatButtonModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [
    PatientsPage
  ],
  imports: [
    IonicPageModule.forChild(PatientsPage),
    TranslateModule.forChild(), // Required for translation.
    MatFormFieldModule, MatTableModule, MatPaginatorModule, MatSortModule, MatInputModule, MatCheckboxModule, MatButtonModule, MatIconModule,
    DirectivesModule
  ],
})
export class PatientsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patients/patients.module.ts